<template>
  <div class="account-container" v-if="authenticated">
    <ul class="nav">
      <router-link :to="{ name: 'account-edit' }">
        <li>Edit Profile</li>
      </router-link>
      <router-link :to="{ name: 'account-social' }">
        <li>Linked Account</li>
      </router-link>
      <router-link :to="{ name: 'account-password' }">
        <li>Change Password</li>
      </router-link>
      <router-link :to="{ name: 'account-settings' }">
        <li>Settings</li>
      </router-link>
    </ul>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'account',
  computed: {
    ...mapState('auth', ['authenticated']),
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.account-container {
  padding: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: left;
  vertical-align: middle;
  line-height: 1;
}

.nav {
  display: flex;
  flex-direction: column;
  width: 15rem;
  list-style-type: none;
}

.nav li {
  cursor: pointer;
  padding-bottom: 1rem;
  font-size: 1rem;
  white-space: nowrap;
  margin: 0 1rem;
}

.nav a {
  text-decoration: none;
  color: grey;
}

.content {
  width: 60rem;
  border: 0.01rem solid #e1e1e1;
  min-height: 30rem;
}


@media screen and (max-width: 811px) {
  .content {
    border: none;
  }

  .account-container {
    flex-direction: column;
  }

  .nav {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    list-style-type: none;
    line-height: 1;
    border-bottom: 1px solid rgba(194, 194, 194, 0.514);
    margin: 1rem 0 0 0;
    padding-left: 0;
  }

  .content {
    width: 100%;
  }

}

.router-link-active li {
  color: $router-link;
  font-weight: 500;
}

</style>
